import React from "react";
import { Bat, Ghost, Pumpkin } from "./sprites";

/**
 * A string of pumpkins, bats and ghosts hung along the bottom edge of the
 * header, each swinging on its own beat.
 *
 * Fixed-width cells rather than a stretched drawing: the string's sag stays the
 * same shape on every screen, and a wide monitor just shows more of it.
 *
 * `compact` is the realtor panel's size — smaller charms on a shallower string,
 * so they hang over the filter bar's margin rather than over its inputs.
 */

var CELLS = [];
for (var i = 0; i < 28; i++) CELLS.push(i);

/** Charm widths at full size: pumpkin, bat, ghost. */
var WIDTHS = [20, 26, 16];

function Charm({ index }) {
  var kind = index % 3;
  if (kind === 0) return <Pumpkin faceDelay={-index * 0.4} />;
  // Mid-purple rather than night-black, so the bats show over the dark hero
  // and the white pages alike.
  if (kind === 1) return <Bat color="#5B3A8E" flap={false} />;
  return <Ghost />;
}

export default function HeaderGarland({ compact }) {
  var scale = compact ? 0.72 : 1;
  return (
    <div className={"hw-garland" + (compact ? " hw-garland--compact" : "")} aria-hidden="true">
      {CELLS.map((index) => {
        var width = Math.round(WIDTHS[index % 3] * scale);
        return (
          <div className="hw-garland-cell" key={index}>
            <svg className="hw-garland-string" viewBox="0 0 96 14" preserveAspectRatio="none">
              <path
                d="M0 1 Q48 14 96 1"
                fill="none"
                stroke="#8C7BB5"
                strokeWidth="1.2"
                vectorEffect="non-scaling-stroke"
              />
            </svg>
            <div
              className="hw-garland-item"
              style={{
                animationDelay: -(index * 0.37) + "s",
                width: width,
                marginLeft: -Math.round(width / 2),
              }}
            >
              <Charm index={index} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
